import { useListEntityApi } from "@/common/api/listEntityApi";
import type { DashboardResponse } from "./common/dashboardResponse";

interface DashboardPageResponse {
  dashboards: DashboardResponse[];
}

export interface ListDashboardResponse {
  ok: true;
  dashboards: DashboardResponse[];
}

export function useListDashboardApi() {
  return useListEntityApi<ListDashboardResponse>({
    url: 'dashboard',
    translate: (t) => t.dashboard.actions.fetchMany,
    async processOk(response) {
      const data = await response.json() as DashboardPageResponse;
      return {
        ok: true,
        dashboards: data.dashboards
      };
    },
  });
}
